import client from './client';

export interface Category {
  id: number;
  name: string;
  slug: string;
  icon: string;
  image_url?: string;
  display_order: number;
  is_active: boolean;
}

export const categoriesAPI = {
  async listCategories(): Promise<Category[]> {
    const response = await client.get<Category[]>('/api/categories/');
    return response.data;
  },

  async createCategory(data: { name: string; icon?: string; image_url?: string; display_order?: number }): Promise<Category> {
    const response = await client.post<Category>('/api/categories/', data);
    return response.data;
  },
};

